export default class RPKundendatenRequest {
  id: string
  kundeNachname: string
  kundeVorname: string
  kundeTelefon: string
  kundeEmail: string
}
